import { render, staticRenderFns } from "./Loader.vue?vue&type=template&id=9032db88&scoped=true"
import script from "./Loader.vue?vue&type=script&lang=ts"
export * from "./Loader.vue?vue&type=script&lang=ts"
import style0 from "./Loader.vue?vue&type=style&index=0&id=9032db88&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9032db88",
  null
  
)

export default component.exports